var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBird(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2069_16750",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.744 9.78038L9.78125 0L0.000869585 29.9628L29.9636 39.7432L39.744 9.78038Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2069_16750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8748 15.6107C15.6155 15.4137 14.0804 14.2927 12.0289 14.9163C9.36553 15.7263 8.32541 18.7191 8.26953 18.887C8.77383 12.591 9.27743 6.29397 9.78173 -0.00390625L15.8748 15.6107Z",
    fill: "#145E84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9145 30.1135L10.2812 24.0166L38.6889 13.0117L16.9145 30.1135Z",
    fill: "#10405D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9141 30.1138L20.6906 27.1494L25.5802 38.313L16.9141 30.1138Z",
    fill: "#4B9ABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37972 20.8076C7.67987 21.566 7.98143 22.3238 8.28301 23.081L4.26367 25.2866C5.30235 23.7939 6.34104 22.301 7.37972 20.8076Z",
    fill: "#135D84"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBird);
export default __webpack_public_path__ + "static/media/logo_bird.c0d5319fdd90b911bc84f4cb591b3d39.svg";
export { ForwardRef as ReactComponent };